export var WhiteSpaceProperty;
(function (WhiteSpaceProperty) {
    WhiteSpaceProperty["normal"] = "normal";
    WhiteSpaceProperty["noWrap"] = "nowrap";
    WhiteSpaceProperty["pre"] = "pre";
    WhiteSpaceProperty["preLine"] = "pre-line";
    WhiteSpaceProperty["preWrap"] = "pre-wrap";
})(WhiteSpaceProperty || (WhiteSpaceProperty = {}));
